import React from 'react';
import RoadmapFeature from './RoadmapFeature';
import RoadmapDetailComponent from './details/PublicRoadmapDetails';
import FeatureRequests from './FeatureRequests';
import PublicChangelogs from './changelogs/PublicChangelogs';

const RoadmapContent = ({
    name,
    navOption,
    changelog_controls,
    allRoadmaps,
    poweredBy,
    openRoadmapDetailsPage,
    createUpvotes,
    saveCommentsLoader,
    commentsAlert,
    roadmapInfo,
    comentsUpvote,
    setcommentsInfo,
    commentsInfo,
    getRoadmapDetails,
    companyID,
    roadmapToggle,
    roadmapModal,
    authModalToggle,
    tokenExists,
    getUserToken,
    submitComment,
    filterRoadmaps,
    companyInfo,
}) => {
    if (!name) {
        return (
            <>
                <h2 style={{ marginTop: '20px' }}>Company not found</h2>
                <p>Is the URL correct? No company with that name seems to exist.</p>
                <p>
                    Try going to <a style={{ color: '#525f7f' }} rel="noreferrer" target="_blank" href="https://productlogz.com?utm_source=app&utm_medium=wrong_public_page">Homepage</a>?
                </p>
            </>
        );
    }

    return (
        <div className="publicview-content">
            {navOption.parent === 'roadmap' && (
                <RoadmapFeature
                    allRoadmaps={allRoadmaps}
                    poweredBy={poweredBy}
                    openRoadmapDetails={openRoadmapDetailsPage}
                    createUpvotes={createUpvotes}
                    companyInfo={companyInfo}
                />
            )}
            {navOption.parent === 'feature_requests' && (
                <span>
                    {navOption.slug?.length > 0 ? (
                        <RoadmapDetailComponent
                            upvoteHandler={createUpvotes}
                            submitComment={submitComment}
                            saveCommentsLoader={saveCommentsLoader}
                            commentsAlert={commentsAlert}
                            roadmapInfo={roadmapInfo}
                            comentsUpvote={comentsUpvote}
                            type={'public'}
                            setcommentsInfo={setcommentsInfo}
                            commentsInfo={commentsInfo}
                        />
                    ) : (
                        <FeatureRequests
                            allRoadmaps={allRoadmaps}
                            getRoadmapDetails={getRoadmapDetails}
                            companyID={companyID}
                            createUpvotes={createUpvotes}
                            poweredBy={poweredBy}
                            roadmapToggle={roadmapToggle}
                            openRoadmapDetails={openRoadmapDetailsPage}
                            roadmapModal={roadmapModal}
                            authModalToggle={authModalToggle}
                            tokenExists={tokenExists}
                            getUserToken={getUserToken}
                            filterRoadmaps={filterRoadmaps}
                            companyInfo={companyInfo}
                        />
                    )}
                </span>
            )}
            {navOption.parent === 'changelog' && changelog_controls.show_changelog && (
                <PublicChangelogs
                    companyInfo={companyInfo}
                />
            )}
        </div>
    );
};

export default RoadmapContent;
